"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.callback = callback;
var _context = require("../context");
var _error = require("../error");
/*
* Copyright (c) 2020 Wells Fargo, All rights reserved.
*
* This software is the confidential and proprietary information of Wells Fargo
* bank. ('Confidential Information'). You shall not disclose such Confidential
* Information and shall use it only in accordance with the terms of the license
* agreement you entered into with WellsFargo.
*/

/**
 * Callback Handler
 * - Invokes an SDK callback function
 *
 * @module core-bootstrap-callback-handler
 */

/**
 * Calls a partner supplied callback funcrtion with data from the SDK IFrame
 *
 * @param {*} data The callback data
 * @param {*} id iframeEntry The iframe handle
 * @param {*} action The callback function name & context
 */
function callback(data, id, action) {
  var iframeEntry = (0, _context.getIframeConfiguration)(id);
  if (!iframeEntry) {
    return;
  }
  var callbackContext = 'not_provided';
  var callbackFunction = 'not_provided';
  if (action) {
    var actionParts = action.split(':');
    if (actionParts.length >= 3) {
      callbackContext = actionParts[1];
      callbackFunction = actionParts[2];
    } else {
      (0, _error.handleError)("Invalid action passed to callback dispatch: ".concat(action));
    }
  } else {
    (0, _error.handleError)("Invalid action passed to callback dispatch: ".concat(action));
  }
  if (iframeEntry && iframeEntry.config && iframeEntry.config.callbacks && iframeEntry.config.callbacks[callbackContext] && iframeEntry.config.callbacks[callbackContext][callbackFunction]) {
    try {
      // invoke merchant supplied callback function
      iframeEntry.config.callbacks[callbackContext][callbackFunction](data);
    } catch (err) {
      (0, _error.handleError)('Error thrown by callback function: ' + err, iframeEntry.config);
    }
  }
}
//# sourceMappingURL=callback.js.map